export default {"src":"/_next/static/media/sid-work.f32e1be0.svg","height":201,"width":1030};